import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { handleErrorResponse } from "../../apis";

export const getFacilityBoxes = createAsyncThunk('getFacilityBoxes', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/get-facility-boxes`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const changeShipmentStatus = createAsyncThunk('changeShipmentStatus', async (data, {rejectWithValue}) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/india-supply/vendor/change-shipment-status`
    try {
        const response = await axios.post(URL, data);
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});
